import { i18n } from '@/localize';
export class DataSource {
  /**
   * @param  {Number} key The Enum key
   * @param  {String} title The title
   */
  constructor (key, title) {
    this.key = key;
    this.title = title;
  }
}

export class ForcedFilter {
  /**
   * @param  {String} selector For example 'RelationID'
   * @param  {Number} selectedKey For example 12
   */
  constructor (selector, selectedKey) {
    this.selector = selector;
    this.selectedKey = selectedKey;
  }
}

export class ContextMenuItem {
  /**
   * @param  {String} title The title for the context menu
   * @param  {Function} method The method to execute
   * @param  {Boolean} allowMultiSelect Show or hide button when multiple rows are selected
   * @param  {Boolean} forRow Show or hide when any row is selected
   * @param  {Array<ContextMenuItem>} children The child context menu items
   * @param  {Object} cssClass The css class to bind
   * @param  {Function} showItemFunc The evaluation for the row to show. receives getRowData
   */
  constructor (title, method, allowMultiSelect, forRow, children, cssClass, showItemFunc) {
    this.title = title;
    this.method = method;
    this.allowMultiSelect = allowMultiSelect;
    this.forRow = forRow;
    this.children = children;
    this.class = cssClass;
    this.showItemFunc = showItemFunc;
  }
  /**
   * ShowItemFunc example: showItemFunc = (row) => {
      return self.readOnly === false;
    };
   */
  static CreateForSelectedRow (children) {
    let title = (count) => i18n.t('grid.context_menu.for_selected_rows', {0: count});
    return new ContextMenuItem(title, null, true, true, children);
  }
  static Delete (deleteMethod, title = i18n.t('delete'), allowMultiSelect = true) {
      return new ContextMenuItem(title, deleteMethod, allowMultiSelect, true, undefined, { 'delete' : true });
  }

}

export class DateFilter {
  /**
   * @param  {String} selector For example 'RelationID'
   * @param  {Date} selectedDate For example 12
   */
  constructor (selector, selectedDate, operator, description, reference) {
    this.selector = selector;
    this.selectedDate = selectedDate;
    this.operator = operator;
    this.description = description;
    this.reference = reference;
  }
}

export class RowMutationHolder {
  constructor (uniqueid, mutationState) {
    this.UniqueID = uniqueid;
    this.MutationState = mutationState;
    this.Error = '';
  }

  resetError () {
    this.Error = '';
  }

  setError (error) {
    this.Error = error;
  }
}

export class BaseCommand {
  constructor (uri) {
    this.Uri = uri;
  }
}

export class Command extends BaseCommand {
  constructor (uri, parameters) {
    super(uri);
    this.Parameters = parameters;
  }
}

export class WebMethod {
  constructor (controller, method, parameters) {
    this.controller = controller;
    this.method = method;
    this.parameters = parameters;
  }
}
